import { Button, Col, Container, ProgressBar, Row } from "react-bootstrap"
import Title from "./Title"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import '../style/scss/tokenomics.scss';
import BuyIco from '../style/images/tokenomics/buyIco.svg'
import AuditIco from '../style/images/tokenomics/auditIco.svg'
import CopyIco from '../style/images/tokenomics/copyIco.svg'

ChartJS.register(ArcElement, Tooltip, Legend);

const Tokenomics = () => {
    const data = {
        labels: ['Fees', 'Liquidity', 'Burn'],
        datasets: [
            {
                label: '',
                data: [3, 0, 0],
                backgroundColor: [
                    '#AAFF00',
                    '#7F8389',
                    '#FFFFFF',
                ],
                borderColor: [
                    '#AAFF00',
                    '#7F8389',
                    '#FFFFFF',
                ],
                borderWidth: 0,
            },
        ],
    };
    const options = {
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        return label;
                    }
                }
            },
        },
        cutout:'65%'
    };

    const plugins = [{
        id: 'text',
        beforeDraw: function (chart, a, b) {
            var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;

            ctx.restore();
            var fontSize = (height / 114).toFixed(2);
            ctx.font = "600 " + fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "white";

            var text = "0%",
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 2;

            ctx.fillText(text, textX, textY);
            ctx.save();
            ctx.restore();
            var fontSize = (height / 500).toFixed(2);
            ctx.font = "100 " + fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "white";

            var text = "TRANSACTION FEES",
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 2 + height / 10;

            ctx.fillText(text, textX, textY);
            ctx.save();
        }
    }];

    const tokenomics = [
        { name: 'Marketing', apy: '3%', progress: '50', color: 'success' },
        { name: 'Liquidity', apy: '2%', progress: '35', color: 'info' },
        { name: 'Burn', apy: '1%', progress: '15', color: 'warning' }
    ]
    return (
        <Container id="TokenomicsSection" className="mt-20">
            <Title title={"Tokenomics"} />
            <Row className="tokenomics mt-5">
                <Col lg={6} md={6} sm={6} xs={12} className="d-flex flex-column justify-content-center gap-4 content">
                    <h2 className="">Hulk Token</h2>
                    <p className="hulk-desc">
                        HULK token is a utilities token tied to the entire Hulk Ecosystem. It will give many advantages to our partners, access to premium services and exclusive discounts see the whitepaper to find out more.
                    </p>
                    <Row>
                        <Col>
                            <p>Contract address:<span style={{ color: '#ACEB2F' }}>0x</span></p>
                        </Col>
                        <Col>
                            <img src={CopyIco} height={13} style={{ cursor: "pointer" }}></img>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="flex-column d-flex">
                            <Col className="flex-column">
                                <div className="description">Token name:</div>
                                <p>Hulk Token</p>
                            </Col>
                            <Col className="flex-column">
                                <div className="description">Total Supply:</div>
                                <p>1000.000.000</p>
                            </Col>
                        </Col>
                        <Col className="flex-column d-flex">
                            <Col className="flex-column">
                                <div className="description">Symbol:</div>
                                <p>HULK</p>
                            </Col>
                            <Col className="flex-column">
                                <div className="description">Available on:</div>
                                <p>Solana</p>
                            </Col>
                        </Col>
                        <div className="d-flex flex-row gap-3">
                            <Button className=""><img src={BuyIco} height={24}></img><span> Buy Hulk</span></Button>
                            <Button className=""><img src={AuditIco} height={22}></img>Audit</Button>
                        </div>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12} className="chart d-flex justify-content-center items-align-center">
                    <Doughnut data={data} options={options} plugins={plugins} />
                </Col>
                {/* <Col lg={6} md={6} sm={6} xs={12} className="d-flex flex-column justify-content-center gap-5 content">
                    {
                        tokenomics.map((token, index) => {
                            return (
                                <div className="token" key={index}>
                                    <h6 style={{fontSize: "25px", fontFamily: "Raleway", color: "#FFFFFF", fontWeight: "500"}}>{token.name} {token.apy}</h6>
                                    <ProgressBar variant={token.color} now={token.progress} />
                                </div>
                            )
                        })
                    }
                </Col> */}
            </Row>
        </Container>
    )
}

export default Tokenomics;